// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ayn1S","rootMobile":"styles_rootMobile__VjMyn"};